import { useEffect, useRef } from 'react'
import styles from './WorklogContextMenu.module.css'

export default function WorklogContextMenu({
    isVisible,
    position,
    onClose,
    onDuplicate,
    onDuplicateForMe,
    onSplit,
    onDelete,
    worklog
}) {
    const menuRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose()
            }
        }

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose()
            }
        }

        if (isVisible) {
            document.addEventListener('mousedown', handleClickOutside)
            document.addEventListener('keydown', handleKeyDown)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [isVisible, onClose])

    if (!isVisible) return null

    const menuItems = [
        {
            label: 'Duplicate',
            shortcut: '⌥ + (Drag/Click)',
            action: onDuplicate
        },
        {
            label: 'Duplicate for me',
            shortcut: '⌥ + ⇧ + (Drag/Click)',
            action: onDuplicateForMe
        },
        {
            label: 'Split',
            shortcut: '⌘ + Click',
            action: onSplit
        },
        {
            label: 'Delete',
            shortcut: 'Focus + Delete',
            action: onDelete,
            destructive: true
        }
    ]

    return (
        <div
            ref={menuRef}
            className={styles.contextMenu}
            style={{
                left: position.x,
                top: position.y
            }}
        >
            {menuItems.map((item, index) => (
                <div
                    key={index}
                    className={`${styles.menuItem} ${item.destructive ? styles.destructive : ''}`}
                    onClick={() => {
                        item.action()
                        onClose()
                    }}
                >
                    <div className={styles.menuItemContent}>
                        <span className={styles.menuLabel}>{item.label}</span>
                    </div>
                    <span className={styles.menuShortcut}>{item.shortcut}</span>
                </div>
            ))}
        </div>
    )
}